{
    "app": {
        "Welcome": "Välkommen",
        "Notifications": "Notifieringar",
        "New": "Ny"
    },
    "commands": {
        "Add": "Lägg till",
        "Delete":  "Radera", 
        "Edit": "Ändra",
        "Save": "Spara",
        "Cancel": "Avbryt",
        "Reset": "Återställ",
        "Reload": "Ladda om",
        "Search": "Sök",
        "OK": "OK",
        "Close": "Stäng",
        "Print": "Skriv ut",
        "SaveAndClose": "Spara och stäng",
        "Back": "Tillbaka",
        "Options": "Alternativ",
        "Activate":  "Aktivera" 
    },
    "form": {
        "ErrorCaption": "Information saknas",
        "ErrorMessage": "Felaktig eller saknad information. V.g. korrigera och försök igen."
    },
    "globalTexts": {
        "SearchInstruction": "Sök...",
        "ChooseInstruction": "Välj...",
        "Error": "Fel",
        "deleted": "raderad",
        "activated":  "aktiverad", 
        "saved": "sparad",
        "FetchErrorMessage": "Kunde inte hämta data från servern",
        "SavingMessage": "Sparar...",
        "DeleteError": "Fel vid radering",
        "DeletingMessage": "Raderar...",
        "ConfirmLeave": "Ändringar har gjorts. Vill du avbryta ändå?",
        "CouldNotSave": "Kunde inte spara",
        "SaveErrorMessage": "Ett eller flera fel inträffade när informationen skulle sparas:",
        "DirtyFormBackQuery": "Informationen har ändrats. Vill då gå tillbaka ändå?",
        "DirtyFormContinueQuery": "Informationen har ändrats. Vill då gå vidare ändå?",
        "Scope": "Omfattning"
    },
    "home": {
        "NoWidgets1": "You have no widgets displayed. Goto",
        "NoWidgets2": "to configure available widgets",
        "StatisticsTitle": "Some Important Stuff"
    },
    "function": {
        "About": "Om",
        "Account": "Konto",
        "Administration": "Administration",
        "Businesses": "Verksamheter",
        "Financiers": "Finansiärer",
        "Home": "Hem",
        "Login": "Logga in",
        "Logout": "Logga ut",
        "NotFound": "Saknas",
        "Organizations": "Organisationer",
        "Profile": "Profil",
        "Reports": "Rapporter",
        "Roles": "Roller",
        "Settings": "Inställningar",
        "Theme": "Välj ett tema",
        "UserAccount": "Användarkonto",
        "Users": "Användare"
    },
    "scoring": {
        "NotSignificant": "Ej signifikant",
        "NotApplicable":  "Ej tillämpligt", 
        "ActionsRequired": "Åtgärd krävs",
        "Acceptable": "Godtagbart",
        "Good": "Bra",
        "VeryGood": "Mycket bra",
        "Excellent": "Utmärkt",
        "Outstanding": "Enastående"
    },
    "notFound": {
        "404": "404",
        "pageNotFound": "Sidan saknas",
        "backToHome": "Tillbaka till startsidan"
    },
    "paginator": {
        "items_per_page": "Sidstorlek",
        "next_page": "Nästa sida",
        "of": "av",
        "previous_page": "Föregående sida"
    },
    "preferences": {
        "SavePreferences": "Spara inställningarna?",
        "SavePreferencesHint": "Inställningarna sparas i molnet.",
        "ReloadPreferences": "Ladda om inställningarna?",
        "ReloadPreferencesHint": "Inställningarna laddas om",
        "ResetPreferences": "Återställ inställningarna?",
        "ResetPreferencesHint": "Återställer inställningarna till standard (lokalt)",
        "Language": "Språk",
        "English": "Engelska",
        "Swedish": "Svenska",
        "LanguageHint": "Välj språk",
        "HomePage": "Startsida",
        "Dashboard": "Dashboard",
        "Customers": "Customers",
        "Products": "Products",
        "Orders": "Orders",
        "About": "Om",
        "Settings": "Inställningar",
        "HomePageHint": "Välj startsida vid inloggning",
        "DashboardStatistics": "Dashboard Statistics",
        "DashboardStatisticsHint": "Show demo graph widget on the dashboard",
        "DashboardNotifications": "Dashboard Notifications",
        "DashboardNotificationsHint": "Show application notifications on the dashboard",
        "DashboardTodo": "Dashboard Todo",
        "DashboardTodoHint": "Shows demo todo widget on the dashboard",
        "DashboardBanner": "Dashboard Banner",
        "DashboardBannerHint": "Show demo information banner widget on the dashboard"
    },
    "settings": {
        "tab": {
            "Profile": "Profil",
            "Preferences": "Inställningar",
            "Users": "Användare",
            "Roles": "Roller"
        },
        "description": {
            "UserProfile": "Ändra din profil",
            "UserPreferences": "Ändra dina inställningar",
            "UsersManagement": "Administrera användare",
            "RolesManagement": "Administrera roller"
        }
    },
    "users": {
        "management": {
            "NewUser": "Lägg till användare",
            "Edit": "Ändra användare",
            "Delete": "Radera användare",
            "EditUser": "Ändra användare \"{{name}}\"",
            "Title": "Titel",
            "UserName": "Användarnamn",
            "FullName": "Namn",
            "Email": "E-post",
            "Roles": "Roller",
            "PhoneNumber": "Telefon",
            "IsEnabled": "Aktiv?"
        },
        "editor": {
            "JobTitle": "Titel",
            "UserName": "Användarnamn",
            "UserNameRequired": "Användarnamn är obligatoriskt (2-200 tecken)",
            "Password": "Lösenord",
            "PasswordHint": "Lösenord måste anges när användarnamn ändras",
            "CurrentPasswordRequired": "Nuvarande lösenord måste anges",
            "Email": "E-post",
            "EmailRequired": "E-post är obligatoriskt (max 200 tecken)",
            "InvalidEmail": "Ogiltig e-postadress",
            "ChangePassword": "Byt lösenord",
            "CurrentPassword": "Nuvarande lösenord",
            "NewPassword": "Nytt lösenord",
            "NewPasswordRequired": "Nytt lösenord krävs",
            "NewPasswordRules": "Det nya lösenordet måste åtminstone innehålla: En versal, en gemen, en siffra och ett specialtecken",
            "ConfirmPassword": "Bekräfta lösenord",
            "ConfirmationPasswordRequired": "Lösenordet måste bekräftas",
            "PasswordMismatch": "Det nya lösenorden matcher inte varandra",
            "Roles": "Roller",
            "FullName": " För- och efternamn",
            "RoleRequired": " Roll måste anges",
            "PhoneNumber": "Telefon",
            "Enabled": "Aktiv",
            "Unblock": "Lås upp",
            "Close": "Stäng",
            "Edit": "Redigera",
            "Cancel": "Avbryt",
            "Save": "Spara",
            "Saving": "Sparar..."
        }
    },
    "roles": {
        "management": {
            "NewRole": "Ny roll",
            "Edit": "Ändra",
            "Details": "Detaljer",
            "Delete": "Radera",
            "RoleDetails": "Rolldetaljer \"{{name}}\"",
            "EditRole": "Ändra roll \"{{name}}\"",
            "Name": "Namn",
            "Description": "Beskrivning",
            "Users": "Användare"
        },
        "editor": {
            "Name": "Namn:",
            "Description": "Beskrivning:",
            "RoleNameRequired": "Namn krävs (2 - 200 tecken)",
            "SelectAll": "Välja alla",
            "SelectNone": "Välj ingen",
            "Close": "Stäng",
            "Cancel": "Avbryt",
            "Save": "Spara",
            "Saving": "Sparar..."
        }
    },
    "notifications": {
        "Delete": "Rensa notifiering",
        "Pin": "Fäst notifiering",
        "Date": "Tidpunkt",
        "Notification": "Notifiering"
    },
    "todoDemo": {
        "management": {
            "Search": "Search for task...",
            "HideCompleted": "Hide Completed",
            "ShowCompleted": "Show Completed",
            "AddTask": "Add Task",
            "Delete": "Delete task",
            "Important": "Mark as important",
            "Task": "Task",
            "Description": "Beskrivning"
        },
        "editor": {
            "NewTask": "New Task",
            "Name": "Name",
            "TaskNameRequired": "Task name is required",
            "Description": "Beskrivning",
            "Important": "Mark as important",
            "AddTask": "Add Task"
        }
    }
}
